import { createSlice } from '@reduxjs/toolkit';
import { API_POST } from '../../../services';
import { ENDPOINTS } from '../../../constants/endPoints';
import { OverallMetrics } from '../../../models/LineGraphModels';
import { RootState } from '../../store';
import { env } from '../../../env';
import { createAppAsyncThunk } from '../../createAppAsyncThunk';
import { RADRequest } from '../../../models/common/RADRequest';

interface OverallState {
  overallPerformanceData: OverallMetrics | null;
  isLoading: boolean;
}

const initialState: OverallState = {
  overallPerformanceData: null,
  isLoading: false,
};

export const fetchOverallData = createAppAsyncThunk<OverallMetrics, RADRequest>(
  'overall/fetchOverallData',
  async (params: RADRequest) => {
    const payload = {
      storeNumber: params.storeNumber,
      isMultiStoreMode: params.isMultiStoreMode ?? false,
    };
    const response = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_OVERALL_DATA}`,
      payload,
    );
    return response;
  },
);

const overallSlice = createSlice({
  name: 'overall',
  initialState,

  reducers: {
    clearOverallPerformanceData: state => {
      state.overallPerformanceData = null;
      state.isLoading = false;
    },
  },

  extraReducers: builder => {
    builder
      .addCase(fetchOverallData.pending, state => {
        state.isLoading = true;
        state.overallPerformanceData = null;
      })
      .addCase(fetchOverallData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.overallPerformanceData = action.payload;
      })
      .addCase(fetchOverallData.rejected, state => {
        state.isLoading = false;
      });
  },
});

export const selectOverallPerformanceData = (state: RootState) => state.overall.overallPerformanceData;
export const selectOverallLoading = (state: RootState) => state.overall.isLoading;

export const { clearOverallPerformanceData } = overallSlice.actions;

export default overallSlice.reducer;
